<div class="top-row-controls-container">
  <scaffold-search-bar id="srchbx"
  [allowSearch]="true"
  (search)="search($event)"
  [searchPlaceholder]="'search_students'| translation"
  [activePlaceholder]="'student_status'| translation"
  [displayActiveStateFilter]="true"
  [searchData]="this.item?.columns"
  [perPageOptions]="this.item?.pageCounts"
  [(perPage)]="perPage"
  aria-placeholder="search gradebook">
    <div scaffoldSearchAddition3>
      <nb-form-field>
        <input
          nbInput
          [placeholder]="'search_assignments'| translation"
          type="text"
          [(ngModel)]="filter"
          fullWidth="true"
        />
        <button
          nbSuffix
          style="background: transparent"
          nbButton
          ghost
          status="basic"
          type="button"
        >
          <i class="fa-thin fa-magnifying-glass"></i>
        </button>
      </nb-form-field>
    </div>
  </scaffold-search-bar>

  <scaffold-paginate-page-select
    (perPageChange)="perPageChange($event)"
    [perPageOptions]="item?.pageCounts"
    [(perPage)]="perPage"
    [countLabel]="getCountLabel()"
  ></scaffold-paginate-page-select>
</div>
<ng-container
  *ngIf="
    itemCount == 0 || !filteredAssignments(item?.data.assignments)?.length;
    else table
  "
  ><div class="no-result-container" *ngIf="!isLoading">
    <label>{{
      (hasFilters
        ? "no_results_found"
        : itemCount == 0
        ? "no_students_to_display"
        : "no_assignments_to_display")| translation
    }}</label>
  </div>
  <div style="display: flex; justify-content: center" *ngIf="isLoading">
    <i style="font-size: 30px" class="fas fa-spinner fa-spin"></i>
  </div>
</ng-container>
<ng-template #table>
  <div class="loading-table-wrapper">
    <div class="loading-table-overlay-spinner-container" *ngIf="isLoading">
      <i class="fas fa-spinner fa-spin loading-table-overlay-spinner"></i>
    </div>
    <div [ngClass]="{ 'loading-table-overlay': isLoading }">
      <div class="gradebook-table contrast-table">
        <table>
          <thead>
            <tr>
              <th class="archAssigns" (click)="sortByLastName()">
                <div style="cursor: pointer">
                  {{'student_name'| translation}}
                  <i
                    style="margin-left: 10px"
                    class="fas"
                    [ngClass]="{
                      'fa-caret-down': directionAsc,
                      'fa-caret-up': !directionAsc
                    }"
                  >
                  </i>
                </div>
              </th>
              <th
                *ngFor="let col of filteredAssignments(item?.data.assignments)"
                [nbTooltip]="col?.data?.name" [ngClass]="{'hidden-column': !checkVisible(col)}"
              >
                <span (click)="openViewHandler('gradecolumns', col.id)">{{
                  col?.data.name
                }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let student of item?.data.students">
              <th class="student">
                <span (click)="openViewHandler('archiveusers', student.user_id)"
                  >{{ student.user_data.first_name }}
                  {{ student.user_data.last_name }}</span
                >
              </th>
              <td
                *ngFor="let col of filteredAssignments(item?.data.assignments)"
                [ngClass]="{'hidden-column': !checkVisible(col)}"
              >
                <span
                  class="TablesTable-Data-inactive"
                  *ngIf="!(col.grades[student.user_id]?.entry.length > 0)"
                  >{{'no_entry'| translation}}</span
                >
                <span
                  *ngFor="let entry of col.grades[student.user_id].entry"
                  (click)="openViewHandler('gradecolumnentry', entry.id)"
                  [innerHtml]="
                    processScoreDisplay(entry.data, col.data) | safeHtml
                  "
                ></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <scaffold-paginator
          *ngIf="perPage < itemCount"
          [itemCount]="itemCount"
          [(activePage)]="active"
          [perPage]="perPage"
        >
        </scaffold-paginator>
      </div>
    </div>
  </div>
</ng-template>
